import { getUrl, parseBibeHostname } from '../bibe'
import {
  CALLBACKS_PRODUCTION_URL,
  OIDC_LOGOUT_PATH,
} from '../oidcAuth/constants'

const PUBLISH_SUBDOMAIN = 'publish'
const PUBLISH_LOCAL_PORT = ':8888'

export function getCallbacksBaseUrl(): string {
  const { envModifier } = parseBibeHostname()
  return `https://callbacks.${envModifier}buffer.com`
}

/**
 * Publish URL for the current environment, which keeps the prefixes the current
 * hostname carries: a bibe stays on its bibe, a branch deploy on its branch.
 */
export function getPublishUrl(subpath = ''): string {
  const { bibePrefix, effectiveHostname, envModifier } = parseBibeHostname()
  const currentSubdomain = effectiveHostname.split('.')[0]
  const targetHostname =
    currentSubdomain === PUBLISH_SUBDOMAIN
      ? effectiveHostname
      : effectiveHostname.replace(currentSubdomain, PUBLISH_SUBDOMAIN)
  const port = envModifier === 'local.' ? PUBLISH_LOCAL_PORT : ''

  return `https://${bibePrefix}${targetHostname}${port}/${subpath}`
}

export function getPortFromURL(baseUrl: string): string {
  const port = baseUrl.match(/(?<port>:\d+)/)?.groups?.port
  return port || ''
}

export function getQueryParameters(baseUrl: string): string {
  const query = baseUrl.match(/\?(?<query>.*)$/)?.groups?.query
  // NOTE: returned with a starting "&", because it is always used after the
  // initial query parameter, "?redirect="
  return query ? `?${encodeURI(query)}` : ''
}

export function getProductPath(baseUrl: string): string {
  const result = baseUrl.match(/https*:\/\/(.+)\.buffer\.com/)
  let productPath = baseUrl
  if (result instanceof Array) {
    ;[, productPath] = result
  }
  return productPath
}

function getRedirectUrl(baseUrl: string): string {
  const productPath = getProductPath(baseUrl)
  const port = getPortFromURL(baseUrl)

  return `https://${productPath}.buffer.com${port}`
}

function getRedirectUrlWithParams(baseUrl: string): string {
  return `${getRedirectUrl(baseUrl)}${
    window.location.pathname
  }${getQueryParameters(baseUrl)}${encodeURI(window.location.hash)}`
}

function getLoginOrLogoutUrl(baseUrl = '', loginOrLogoutPath: string): string {
  const redirect = getRedirectUrlWithParams(baseUrl)

  return getUrl(`login.buffer.com/${loginOrLogoutPath}?redirect=${redirect}`)
}

export function getLoginUrl(baseUrl: string): string {
  return getLoginOrLogoutUrl(baseUrl, 'login')
}

export function getLogoutUrl(baseUrl: string): string {
  return getLoginOrLogoutUrl(baseUrl, 'logout')
}

export function getOidcLogoutUrl(): string {
  return getUrl(`${CALLBACKS_PRODUCTION_URL}${OIDC_LOGOUT_PATH}`)
}
